import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { Field, Form, Formik } from 'formik';
import { useMemo } from 'react';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { InputField } from '../../components/InputField/InputField';
import { Configuration } from '../../../models/Configuration/Configutration';
import { toast } from 'react-toastify';

function Foo({ type, settings, ...props }: any) {
  switch (type) {
    case 'text':
      delete props.onChange;
      return <InputField {...props} />;
    case 'select':
      return (
        <Field style={{ width: '100%' }} component={Select} {...props}>
          {settings?.options?.map(({ value, label }: any) => (
            <Select.Option key={value} value={value}>
              {label}
            </Select.Option>
          ))}
        </Field>
      );
    default:
      return <>?</>;
  }
}

function UpdateConfiguration() {
  const { data: configurations = [], isLoading } = useQuery(
    ['configuration'],
    Configuration.all
  );

  const initialValues = useMemo(() => {
    const obj: any = {};
    configurations.forEach((conf) => {
      obj[conf.id] = conf.value;
    });
    return obj;
  }, [configurations]);

  if (isLoading) return <>Loading...</>;

  return (
    <>
      <h1 className="cs-title">Osnovna podešavanja</h1>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            await Configuration.update(values);
            toast.success('Sačuvano!');
          } catch (error: any) {
            toast.error('Greška pri snimanju.');
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ values, setFieldValue }) => (
          <Form className="cs-form-wrapper">
            {configurations.map((conf) => (
              <FormGroup key={conf.id}>
                <FormLabel>{conf.label}</FormLabel>
                <Foo
                  type={conf.type}
                  settings={conf.settings}
                  name={conf.id.toString()}
                  value={values[conf.id]}
                  onChange={(value: any) =>
                    setFieldValue(conf.id.toString(), value)
                  }
                />
              </FormGroup>
            ))}
            <ButtonPrimary type="submit">Sačuvaj</ButtonPrimary>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default UpdateConfiguration;
